import { render, staticRenderFns } from "./AreaDataSubsystem.vue?vue&type=template&id=101970f2"
import script from "./AreaDataSubsystem.vue?vue&type=script&lang=js"
export * from "./AreaDataSubsystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports